import { SingleComboBox } from "@itandi/itandi-bb-ui/SingleComboBox";
import type { ComponentProps } from "react";
import { useCallback, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useVendorPartners } from "~/hooks/vendors/useVendorPartners";
import type { DealSearchCondition } from "~/models/Deal";
import type { VendorPartner } from "~/models/VendorPartner";
import { convertToComboBoxOption } from "~/models/VendorPartner";

type Props = {
	dealSearchCondition: DealSearchCondition;
};
type SingleComboBoxOption = Exclude<
	ComponentProps<typeof SingleComboBox>["options"][number],
	{ group: string }
>;

export function VendorPartnerCombobox({ dealSearchCondition }: Props) {
	const { data: vendorPartners } = useVendorPartners().index();
	const { setValue } = useFormContext<DealSearchCondition>();
	const noVendorPartnerOption: SingleComboBoxOption = {
		label: "実施会社未指定",
		value: String(-1)
	};
	const vendorPartnerOptions: SingleComboBoxOption[] = [
		noVendorPartnerOption
	].concat(
		vendorPartners?.map((vp: VendorPartner) => convertToComboBoxOption(vp)) ??
			[]
	);
	const [selectedVendorPartnerOption, setSelectedVendorPartnerOption] =
		useState<SingleComboBoxOption | null>(
			vendorPartnerOptions.find(
				({ value }) => value === String(dealSearchCondition.partnerVendorId)
			) ?? null
		);
	const onVendorPartnerChange = useCallback(
		(value: SingleComboBoxOption | null): void => {
			setSelectedVendorPartnerOption(value);
			setValue("partnerVendorId", value ? Number(value.value) : undefined);
		},
		[setValue]
	);
	if (vendorPartners === null) {
		return null;
	}
	return (
		<SingleComboBox
			onChange={onVendorPartnerChange}
			options={vendorPartnerOptions}
			placeholder="実施会社"
			value={selectedVendorPartnerOption}
		/>
	);
}
